import { Link } from "react-router-dom";

interface CTAButtonProps {
  variant?: "primary" | "nav" | "outline" | "secondary";
  size?: "sm" | "md" | "lg";
  to?: string;
  href?: string;
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

export default function CTAButton({
  variant = "primary",
  size = "md",
  to,
  href,
  children,
  onClick,
  className = "",
}: CTAButtonProps) {
  const baseClasses =
    "inline-flex items-center justify-center font-body font-semibold whitespace-nowrap transition-all duration-200 tracking-wide uppercase";

  const sizeClasses = {
    sm: "px-4 py-2 text-xs",
    md: "px-6 py-3 text-sm",
    lg: "px-8 py-4 text-sm",
  };

  const variantClasses = {
    primary:
      "bg-strike-500 text-onyx-50 hover:bg-strike-400 active:bg-strike-600",
    nav: "bg-strike-500 text-onyx-50 hover:bg-strike-400 active:bg-strike-600 shadow-lg shadow-strike-500/20",
    outline:
      "border border-strike-500 text-strike-500 hover:bg-strike-500 hover:text-onyx-50",
    secondary:
      "border border-white/20 text-white/40 hover:border-white/40 hover:text-white/70",
  };

  const classes = `${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${className}`;

  if (to) {
    return (
      <Link to={to} className={classes} onClick={onClick}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a
        href={href}
        className={classes}
        onClick={onClick}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  }

  return (
    <button type="button" className={classes} onClick={onClick}>
      {children}
    </button>
  );
}